import {defineAsyncComponent} from 'vue';

export const HitAvatar = defineAsyncComponent(() => import('./HitAvatar.vue'));
